import { useNavigate } from 'react-router-dom';

import { Box, Button } from '@mui/material';

import { Icon } from '@iconify/react';

import { useTranslation } from '../common/LocalizationProvider';

export default function ButtonUpgradePro() {
  const t = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Box
          component="img"
          src="/static/illustrations/illustration_avatar.png"
          sx={{ width: 200, position: 'absolute', top: -50 }}
        />

        <Button
          fullWidth
          onClick={() => navigate('/subscription/plans', { replace: true })}
          variant="contained"
          size="large"
          startIcon={<Icon icon="material-symbols:lock" />}
        >
          {t('DB_SideBar_HaveATry')}
        </Button>
      </Box>
    </div>
  );
}
